import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';

/**
 * for this page
 */
import TopSlide from './topSlide';
import ImgWrapperTab from '../../components/imgWrapperTab';
import ImgNewsWrapper from '../../components/imgNewsWrapper';
import BottomSlide from './bottomSlide';
import NewsImgs from './newsImgs';

class Content extends React.PureComponent {
    state = {
        isFix: styles.ad_r,
    };
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // const ad_rOffsetTop = this.refs.ad_r.offsetTop;
        // console.log(ad_rOffsetTop) 670 1920
        // 悬浮广告
        window.onscroll = () => {
            const ad_rOffsetTop = this.refs.ad_r.offsetTop;
            const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            if (scroll >= 800) {
                if (scroll >= 2730) {
                    this.setState({
                        isFix: styles.ad_r_bottom,
                    });
                } else {
                    this.setState({
                        isFix: styles.ad_r_fix,
                    });
                }
            } else {
                this.setState({
                    isFix: styles.ad_r,
                });
            }
        };
    }

    render() {
        // console.log('content=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        // console.log(content);
        const NewsImgsContent = {
            newsTabs: content.newsTabs,
            newsPhotoData: content.newsPhotoData,
            milPhotoData: content.milPhotoData,
            sportsPhotoData: content.sportsPhotoData,
            historyPhotoData: content.historyPhotoData,
        };

        return (
            <div className={styles.content}>
                <Chip
                    id="55045"
                    type="recommend"
                    title="图片首页轮播大图"
                    groupName="凤凰网资讯图片"
                    content={content.photoTopSlide}
                    translate="handlePhotoTopSlideData">
                    <TopSlide ad={content.topSlideAd} />
                </Chip>
                <div className={styles.space35} />
                <div className={styles.col_1000}>
                    <div className={styles.col_l}>
                        {/* 新闻图片 */}
                        <NewsImgs content={NewsImgsContent} />
                        {/* 在人间模块 */}
                        <div className={styles.mt46}>
                            <Chip
                                id="30076"
                                type="struct"
                                title="在人间-文字导航"
                                groupName="凤凰网资讯图片"
                                content={content.zairjTab}>
                                <ImgWrapperTab />
                            </Chip>
                            <ImgNewsWrapper content={content.zairjData} formatTitle={true} />
                        </div>
                        {/* 地球青年图鉴 */}
                        <div className={styles.mt46}>
                            <Chip
                                id="140037"
                                type="struct"
                                title="地球青年图鉴-文字导航"
                                groupName="凤凰网资讯图片"
                                content={content.globalyouthTab}>
                                <ImgWrapperTab />
                            </Chip>
                            <ImgNewsWrapper content={content.globalyouthData} formatTitle={true} />
                        </div>
                        {/* 特刊模块 */}
                        <div className={styles.mt46}>
                            <Chip
                                id="30077"
                                type="struct"
                                title="特刊-文字导航"
                                groupName="凤凰网资讯图片"
                                content={content.specialIssueTab}>
                                <ImgWrapperTab />
                            </Chip>
                            <ImgNewsWrapper content={content.specialIssueData} />
                        </div>
                        {/* 预留中间广告 */}
                        <div className={styles.ad_m}>
                            <Ad content={content.middleAd} />
                        </div>
                        {/* 影响力模块 */}
                        <div className={styles.yxl}>
                            <h4>影像力</h4>
                            <Chip
                                id="55046"
                                type="recommend"
                                title="图片首页-影像力"
                                groupName="凤凰网资讯图片"
                                content={content.photoBottomSlide}
                                translate="handlePhotoBottomSlideData">
                                <BottomSlide ad={content.bottomSlideAd} />
                            </Chip>
                        </div>
                    </div>
                    <div className={styles.col_r}>
                        {/* 预留右侧悬浮广告 */}
                        <div className={this.state.isFix} ref="ad_r">
                            <Ad content={content.asideAd} />
                        </div>
                    </div>
                </div>
                {/* 预留底部广告 */}
                <div className={styles.ad_b}>
                    <Ad content={content.bottomAd} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
